const flow = {
    steps: [
        {
            key: 'list',
            state: 'holding.dashboard.messages.folder.list',
        },
        {
            key: 'details',
            state: 'holding.dashboard.messages.folder.message',
        },
    ],
};
export default flow;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/messages/states/messages/folder/folder-flow.ts